import { TextButton as Button, TextLink } from '../../../../design-system';
import styled from 'styled-components';
import { COLORS } from '../../../styles/variables';
import { device } from '../../../styles/devices';
import { AlphaTheme } from '../../../../design-system/ThemeProvider/alphaTheme';

export const TileWrapper = styled.div<{ isAlpha?: boolean }>`
  width: ${({ isAlpha }) => (isAlpha ? '339px' : '356px')};
  background-color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.cardSurface ?? COLORS.white};
  border-radius: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.borderRadiusSm ?? '0'};
  overflow: hidden;
  padding: 24px 24px 20px 24px;
  height: 856px;
  /* min-height: 255px; */
  display: flex;
  flex-direction: column;
  @media ${device.tablet} {
    ${({ isAlpha }) => isAlpha && 'width: 575px;'}
  }
`;

export const BuildCta = styled(TextLink)`
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral200 ?? COLORS.grey60} !important;
  text-decoration: none !important;
`;

export const BuildCtaAlpha = styled(BuildCta)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 8px;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral100 ?? '#fdfdfd'} !important;
`;

export const TagAndBuildWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
`;

export const AlphaTrimCopy = styled.span`
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral200};
`;

export const NameAndTrimWrapper = styled.div<{ isAlpha?: boolean }>`
  display: flex;
  height: 104px;
  gap: 8px;
  flex-direction: column;
  text-align: ${({ isAlpha }) => (isAlpha ? 'left' : 'center')};
`;

export const ImageWrapper = styled.div`
  margin: 24px 0;
  display: flex;
  justify-content: center;
`;

export const ImageWrapperAlpha = styled.div<{ imageUrl?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  aspect-ratio: 16/9;
  height: 163.688px;
  border-radius: var(--Sys-BorderRadius-None, 0);
  background: ${({ imageUrl }) => (imageUrl ? `url(${imageUrl})` : 'none')} 50% / cover no-repeat;

  @media ${device.tablet} {
    height: 296.438px;
  }
`;

export const VehicleImage = styled.img<{ isImageExist?: boolean }>`
  width: 260px;
  height: 132px;
  object-fit: cover;
  scale: ${({ isImageExist }) => (isImageExist ? 1.4 : 1.2)};
  @media ${device.mobileL} {
    width: 296px;
  }
`;

export const MSRPWrapper = styled.div`
  gap: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  margin-bottom: 16px;
`;

export const OfferAndCtaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const CreditContainer = styled.div`
  height: 65px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const CreditCTA = styled.button`
  border: none;
  background: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding-top: 16px;
  padding-bottom: 24px;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral100 ?? 'inherit'};
  /* border-top: 1px solid ${COLORS.grey15}; */
`;

export const CTAsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const MainCta = styled.a`
  cursor: pointer;
  background-color: transparent;
  border: none;
  box-shadow: inset 0 0 0 1px ${COLORS.black};
  width: 100%;
  padding: 16px 32px;
  font-family: 'Audi Type';
  color: ${COLORS.black};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.002px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const InventoryCTA = styled(Button)`
  div:nth-child(2) {
    flex-direction: row-reverse;
    gap: 4px;
  }
`;

export const PriceCopy = styled.h4<{ isBold?: boolean }>`
  margin: 0;
  font-family: 'Audi Type';
  letter-spacing: 0.001px;
  font-size: 18px;
  line-height: 28px;
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral100 ?? COLORS.grey80};
`;

export const BonusOfferTitle = styled.h4`
  /* padding-top: 24px; */
  padding-bottom: 12px;
  font-family: 'Audi Type Extended';
  letter-spacing: 0.002px;
  font-size: 18px;
  line-height: 28px;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral100 ?? 'inherit'};
`;
